import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	httpSubmitOtherListing,
	type SubmitListingResponse,
	type SubmitOtherListingPayload
} from '@/features/luxe-submissions/http/luxe-submissions.http'
import { errorHandler } from '@/helpers/utils'
import { MM_SUBMISSIONS_QUERY_KEY } from './use-get-mm-submissions'

export const useSubmitOtherListing = (
	options?: Omit<
		UseMutationOptions<
			SubmitListingResponse,
			unknown,
			SubmitOtherListingPayload
		>,
		'mutationFn'
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: (payload: SubmitOtherListingPayload) =>
			httpSubmitOtherListing(payload),
		...options,
		onSuccess: (...args) => {
			options?.onSuccess?.(...args)
			queryClient.invalidateQueries({
				queryKey: [MM_SUBMISSIONS_QUERY_KEY]
			})
		},
		onError: (error, ...args) => {
			errorHandler(error)
			options?.onError?.(error, ...args)
		}
	})
}
